import en from './remoteMessages.en';
import translations from './remoteTranslations';

const errorKeys = {
    'Pairing must use the same website.': 'errorSameWebsite',
    'Pairing message is too large.': 'errorMessageTooLarge',
    'Invalid connection offer.': 'errorInvalidOffer',
    'Pairing is busy. Please try again shortly.': 'errorBusy',
    'This pairing link has expired. Create a new link on the controller.': 'linkExpired',
    'Invalid pairing credentials.': 'errorCredentials',
    'This link has already been used. Create a new link.': 'errorLinkUsed',
    'Unknown pairing operation.': 'errorOperation',
    'Invalid connection answer.': 'errorAnswer',
    'This session has ended. Create a new link on the controller.': 'errorSessionEnded',
    'Invalid playback message.': 'errorPlayback',
    'The server connection timed out. Please try again.': 'errorServerTimeout',
    'This browser does not support remote viewing.': 'errorUnsupportedBrowser',
    'No direct connection address was found.': 'errorNoCandidate',
};

export function normalizeRemoteLanguage(lang) {
    return Object.prototype.hasOwnProperty.call(translations, lang) ? lang : 'en';
}

export function remoteText(lang, key) {
    if (!Object.prototype.hasOwnProperty.call(en, key)) return en.errorConnection;
    return translations[normalizeRemoteLanguage(lang)][key] || en[key];
}

export function remoteErrorKey(error) {
    if (Object.prototype.hasOwnProperty.call(en, error?.code)) return error.code;
    return errorKeys[error?.message] || 'errorConnection';
}

export function withRemoteLanguage(link, lang) {
    if (!link) return '';
    const url = new URL(link);
    url.searchParams.set('lang', normalizeRemoteLanguage(lang));
    return url.href;
}
